import { AlertTriangle } from "lucide-react";

import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import { ColocaAlert } from "@/shared/components/feedback/ColocaAlert";
import { ColocaDialog } from "@/shared/components/overlays/ColocaDialog";
import useTranslations from "@/shared/lang/useTranslations";

type DeleteCardModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  cardName: string;
  onConfirm: () => void;
  isLoading?: boolean;
};

export const DeleteCardModal = ({
  open,
  onOpenChange,
  cardName,
  onConfirm,
  isLoading = false,
}: DeleteCardModalProps) => {
  const { t } = useTranslations("cards");

  return (
    <ColocaDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t("card_delete_modal_title")}
      description={t("card_delete_modal_description", { name: cardName })}
      size="sm"
      footer={
        <div className="flex w-full items-center justify-end gap-2">
          <ColocaButton variant="ghost" onClick={() => onOpenChange(false)} disabled={isLoading}>
            {t("card_delete_cancel")}
          </ColocaButton>
          <ColocaButton variant="destructive" onClick={onConfirm} loading={isLoading} disabled={isLoading}>
            {t("card_delete_confirm")}
          </ColocaButton>
        </div>
      }
    >
      <ColocaAlert
        variant="destructive"
        icon={AlertTriangle}
        heading={t("card_delete_warning_title")}
        text={t("card_delete_warning_body")}
      />
    </ColocaDialog>
  );
};
